import { Dispatch, FC, SetStateAction } from "react";
import styles from "./bunchGrid.module.scss";
import { TableHeader } from "../../../../../components/grids/components/TableHeader";
import { IColumnToSave } from "../../../../../components/grids/default/defaultGrid";
import { CheckBoxMultiple } from "../../../../../components/checkboxes/checkBoxMultiple";

interface IGridHeaderProps {
    gridId?: string;
    pluginSettings: IPluginSettings
    totalTableWidth: number;
    rowHeight: number;
    multipleSelect?: boolean;
    typeChecked?: string;
    allChecked: boolean;
    setAllChecked: Dispatch<SetStateAction<boolean>>;
    numbering?: boolean;
    filter: any;
    filteredRows: any[];
    data: any[];
    initialLocalSortingData: any;
    setInitialLocalSortingData: (value: any) => void;
    setSortingStatus: (value: boolean) => void;
    setData: (value: any[]) => void;
    compareByOrder: (a: any, b: any) => number;
    sortArrayByField: any;
    searchRowsArray: any[];
    setSearchRows: (value: any) => void;
    renderSortIcon: any;
    savePluginSettingsWidth: () => void;
    handleColumnReorder: any;
    headerRef?: React.RefObject<HTMLDivElement>;
    onHeaderContextMenu: (e: React.MouseEvent) => void;
    searching?: boolean;
    onSort: (value: any, sortedData?: any[]) => void;
    onFilterDelete: (value: any) => void;
    onPageNumberChange: (page: number) => void;
    setGridColumnsToSave: Dispatch<SetStateAction<IColumnToSave>>;
    draggable: boolean;
    onResizeStart?: () => void;
    onResize?: (column: IGridColumn, width: number) => void;
    onResizeEnd?: () => void;
}

export const GridHeader: FC<IGridHeaderProps> = ({
    gridId,
    pluginSettings,
    headerRef,
    totalTableWidth,
    rowHeight,
    multipleSelect,
    typeChecked,
    allChecked,
    setAllChecked,
    numbering,
    filter,
    filteredRows,
    data,
    initialLocalSortingData,
    setInitialLocalSortingData,
    setSortingStatus,
    setData,
    compareByOrder,
    sortArrayByField,
    searchRowsArray,
    setSearchRows,
    renderSortIcon,
    savePluginSettingsWidth,
    handleColumnReorder,
    onHeaderContextMenu,
    searching,
    onSort,
    onPageNumberChange,
    onFilterDelete,
    draggable,
    setGridColumnsToSave,
    onResizeStart,
    onResize,
    onResizeEnd,
}) => {

    const handleSort = (value: any) => {
        if (filteredRows.length > 1) {

            setSortingStatus(false);

            setTimeout(() => {

                const oldProp = initialLocalSortingData.fieldOrderBy;
                const newProp = value.propertyName;

                const newSortState =
                    oldProp !== newProp
                        ? {
                            ...initialLocalSortingData,
                            fieldOrderBy: newProp,
                            orderDesc: true
                        }
                        : {
                            ...initialLocalSortingData,
                            orderDesc: !initialLocalSortingData.orderDesc
                        };

                setInitialLocalSortingData(newSortState);

                const sorted = sortArrayByField(
                    [...data],
                    newProp,
                    newSortState.orderDesc
                );

                setData(sorted);
                setSortingStatus(true);

                onSort(value, sorted);

            }, 0);

        } else {
            onSort(value);
        }
    };

    const handleSearch = (value: string, column: any) => {
        setSearchRows({
            value,
            order: column.order
        });
    };

    return (
        <div
            ref={headerRef}
            style={{
                minWidth: totalTableWidth
            }}
        >
            <table
                className={styles.gridTable}
                style={{
                    width: totalTableWidth,
                    minWidth: totalTableWidth
                }}
                id={gridId}
            >
                <thead
                    className={styles.gridColumnsHeader}
                    style={{
                        height: rowHeight
                    }}
                    onContextMenu={onHeaderContextMenu}
                >
                    <tr
                        className={styles.gridColumn}
                        style={{
                            width: totalTableWidth,
                            minWidth: totalTableWidth,
                            display: "flex"
                        }}
                        onMouseUp={savePluginSettingsWidth}
                    >
                        {
                            multipleSelect && (
                                <td
                                    draggable={false}
                                    className={styles.gridColumnCell}
                                    style={{ width: '45px', minWidth: '45px' }} >
                                    <CheckBoxMultiple checked={typeChecked} onChange={() => setAllChecked(!allChecked)} />
                                </td>
                            )
                        }

                        {numbering && (
                            <td
                                className={styles.gridColumnCell}
                                style={{
                                    width: 45,
                                    minWidth: 45
                                }}
                            />
                        )}

                        {pluginSettings.columns
                            .sort(compareByOrder)
                            .map((item, index) => {

                                if (!item.visibility)
                                    return null;

                                const filtered =
                                    filter.columnFilters.some(
                                        (x: any) => x.name === item.propertyName
                                    );

                                return (
                                    <TableHeader
                                        key={`${item.propertyName}_${index}`}
                                        index={index}
                                        item={item}
                                        filtered={filtered}
                                        pluginSettings={pluginSettings}
                                        sorting
                                        draggable={draggable}
                                        searching={searching}
                                        setGridColumnsToSave={setGridColumnsToSave}
                                        renderSortIcon={renderSortIcon}
                                        filter={filter}
                                        value={
                                            searchRowsArray.find(
                                                x => x.order === item.order
                                            )?.value
                                        }
                                        onColumnReorder={handleColumnReorder}
                                        onPageNumberChange={onPageNumberChange}
                                        onFilterDelete={onFilterDelete}
                                        onSearch={handleSearch}
                                        onSort={handleSort}
                                        cls={{
                                            tD: styles.gridColumnCell,
                                            tooltip: styles.gridColumnHeaderName,
                                            sortingDiv: styles.gridColumnCellButtons,
                                            sortingDivButton: styles.gridSortButton,
                                            searchDropDivButton: styles.searchDropDivButton,
                                            filteredDiv: styles.gridFilterButton
                                        }}
                                        onResizeStart={onResizeStart}
                                        onResize={onResize}
                                        onResizeEnd={onResizeEnd}
                                    />
                                );
                            })}
                    </tr>
                </thead>
            </table>
        </div>
    );
};